import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { AppointmentDetailsKeys } from "modules/AppointmentDetails/queryKeys";
import { ApiInstance } from "utils/Api";

import type { VehicleTyreReplacement } from "models";

export const useTyreReplacementUpdateMutation = () =>
  useTypedMutation({
    mutationFn: (replacement: VehicleTyreReplacement) => ApiInstance.post("/vehicle_tyre_replacements/update", replacement, ENV.appointmentBaseURL),
    onSuccess: replacement => {
      const appointment = typedQueryClient.getQueryData(AppointmentDetailsKeys.view);
      if (!appointment?.car?.tyres?.length) return;

      const tyreIdx = appointment.car.tyres.findIndex(t => t.replacements?.some(r => r.id === replacement.id));
      if (tyreIdx < 0 || !appointment.car.tyres[tyreIdx].replacements?.length) return;

      const replacements = appointment.car.tyres[tyreIdx].replacements;
      const replacementIdx = replacements.findIndex(r => r.id === replacement.id);
      if (replacementIdx < 0) return;

      typedQueryClient.setQueryData(AppointmentDetailsKeys.view, {
        ...appointment,
        car: {
          ...appointment.car,
          tyres: appointment.car.tyres.with(tyreIdx, {
            ...appointment.car.tyres[tyreIdx],
            replacements: replacements.with(replacementIdx, { ...replacements[replacementIdx], ...replacement })
          })
        }
      });
    }
  });
